import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.36376 12.3816H6.90918V13.1435H8.36376V12.3816Z",
			stroke: "#636C7B",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-2-inside-1_136_4028",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M8.36376 12.3816H6.90918V13.1435H8.36376V12.3816Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.36376 12.3816H6.90918V13.1435H8.36376V12.3816Z",
			fill: "#212121"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.90918 12.3816V10.8816H5.40918V12.3816H6.90918ZM8.36376 12.3816H9.86376V10.8816H8.36376V12.3816ZM8.36376 13.1435V14.6435H9.86376V13.1435H8.36376ZM6.90918 13.1435H5.40918V14.6435H6.90918V13.1435ZM6.90918 13.8816H8.36376V10.8816H6.90918V13.8816ZM6.86376 12.3816V13.1435H9.86376V12.3816H6.86376ZM8.36376 11.6435H6.90918V14.6435H8.36376V11.6435ZM8.40918 13.1435V12.3816H5.40918V13.1435H8.40918Z",
			fill: "#636C7B",
			mask: "url(#path-2-inside-1_136_4028)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5458 5.52393H5.45458C4.65124 5.52393 4 6.20617 4 7.04777V18.4766C4 19.3182 4.65124 20.0005 5.45458 20.0005H18.5458C19.3491 20.0005 20.0004 19.3182 20.0004 18.4766V7.04777C20.0004 6.20617 19.3491 5.52393 18.5458 5.52393Z",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.63672 4V6.28577",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.3643 4V6.28577",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 9.33374H20.0004",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCalendar;
